module.exports = __webpack_public_path__ + "03_long_black.08a565d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_long_black.png
// module id = uKih
// module chunks = 0